import { ReactElement, ReactNode } from "react";

interface Props {
  label: string;
  value: ReactNode;
  hint?: ReactNode;
  accent?: ReactNode;
  loading?: boolean;
}

export function KpiTile({
  label,
  value,
  hint,
  accent,
  loading,
}: Props): ReactElement {
  return (
    <div className="group relative bg-white border border-slate-200 rounded-sm px-5 py-4 transition-colors hover:border-slate-300">
      <div className="flex items-start justify-between gap-3">
        <span className="text-[10px] font-semibold uppercase tracking-[0.14em] text-slate-500">
          {label}
        </span>
        {accent}
      </div>
      <div className="mt-2 font-mono text-3xl font-medium text-slate-900 tabular-nums tracking-tight">
        {loading ? (
          <span className="inline-block h-8 w-24 bg-slate-100 rounded-sm animate-pulse" />
        ) : (
          value
        )}
      </div>
      {hint && (
        <div className="mt-1 text-xs text-slate-500 tabular-nums">{hint}</div>
      )}
    </div>
  );
}
